<template>

    <div class="personal-main">
        <div v-if="isOnboarded" class="personal-header">
            <h4>Personal Details</h4>
            <div class="init-button" style="margin-bottom: 6px;">
                <ob-button type="primary" v-if="!updateFlag" @click="isEdit">Update</ob-button>
            </div>
        </div>
        <div v-if="isOnboarded" class="personal-body">
            <ob-spinner v-if="!empInfo"  type="section" loading-text="Loading..."></ob-spinner>
            <template v-else>
                <div v-if="!updateFlag">
                    <div class="row m0" style="padding-bottom:10px;padding-top: 10px;">
                        <div class="col-md-3 pL0">
                            <label>First Name</label>
                            <p class="personalfile_data" v-if="empInfo.FirstName != null && empInfo.FirstName != ''" :title="empInfo.FirstName">{{empInfo.FirstName}}</p>
                            <p class="personalfile_data" v-else>N/A</p>
                        </div>
                        <div class="col-md-3">
                            <label>Middle Name</label>
                            <p class="personalfile_data" v-if="empInfo.MiddleName != null && empInfo.MiddleName != ''" :title="empInfo.MiddleName">{{empInfo.MiddleName}}</p>
                            <p class="personalfile_data" v-else>N/A</p>
                        </div>
                        <div class="col-md-3">
                            <label>Last Name</label>
                            <p class="personalfile_data" v-if="empInfo.LastName != null && empInfo.LastName != ''" :title="empInfo.LastName"> {{empInfo.LastName}}</p>
                            <p class="personalfile_data" v-else>N/A</p>
                        </div>
                        <div class="col-md-3">
                            <label>Designation</label>
                            <p class="personalfile_data" v-if="empInfo.Designation != null && empInfo.Designation != ''" :title="empInfo.Designation">
                                {{empInfo.Designation}}
                            </p>
                            <p class="personalfile_data" v-else>N/A</p>
                        </div>
                    </div>

                    <div class="row m0">
                        <div class="col-md-3 pL0">
                            <label>Gender</label>
                            <p class="personalfile_data" v-if="empInfo.Gender != null && empInfo.Gender != ''" :title="empInfo.Gender == 'Not Specified' || empInfo.Gender == 'NotSpecified' ? 'Not Disclosed' : empInfo.Gender">{{empInfo.Gender == "Not Specified" || empInfo.Gender == "NotSpecified" ? "Not Disclosed" : empInfo.Gender}}</p>
                            <p class="personalfile_data" v-else>N/A</p>
                        </div>
                        <div class="col-md-3">
                            <label>Date of Birth</label>
                            <p class="personalfile_data" v-if="empInfo.DOBString != null && empInfo.DOBString != '' && empInfo.DOBString != '0001/01/01T00:00:00'" :title="empInfo.DOBString">{{empInfo.DOBString | formatDate('MM/DD/YYYY')}}</p>
                            <p class="personalfile_data" v-else>N/A</p>
                        </div>
                    </div>

                    <div class="row m0">
                        <div class="inner-heading">
                            <h4>Contact Information</h4>
                        </div>
                    </div>

                    <div v-if="empInfo.isAdpEmployee">
                      <div class="row m0">
                        <div class="col-md-3 pL0">
                            <label>Primary Email Address</label>
                            <p class="personalfile_data" v-if="empInfo.EmailId != null && empInfo.EmailId != ''" :title="empInfo.EmailId">{{empInfo.EmailId}}</p>
                            <p class="personalfile_data" v-else>N/A</p>
                        </div>
                        <div class="col-md-3">
                            <label>Secondary Email Address</label>
                            <span v-on:mouseover="mouseOver = '1'" v-on:mouseout="mouseOver= ''" >
                                <img v-bind:src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg`" class="img_design" v-tooltip='"The secondary email address is associated with ADP services. You don`t have permission to make changes to the same."'/>
                            </span>
                            <p class="personalfile_data" v-if="empInfo.SecondaryEmailId != null && empInfo.SecondaryEmailId != ''" :title="empInfo.SecondaryEmailId">{{empInfo.SecondaryEmailId}}</p>
                            <p class="personalfile_data" v-else>N/A</p>
                        </div>
                      </div>

                      <div class="row m0" style="padding-top:10px; padding-bottom: 10px;">
                          <div class="col-md-3 pL0" >
                              <label>Primary Phone Number</label>
                              <p class="personalfile_data" v-if="empInfo.PhoneNo != null && empInfo.PhoneNo != ''" :title="empInfo.PhoneNo">{{empInfo.PhoneNo}}</p>
                              <p class="personalfile_data" v-else>N/A</p>
                          </div>
                          <div class="col-md-3">
                              <label>Secondary Phone Number</label>
                              <span v-on:mouseover="mouseOver = '1'" v-on:mouseout="mouseOver= ''" >
                                  <img v-bind:src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg`" class="img_design" v-tooltip='"The secondary phone number is associated with ADP services. You don`t have permission to make changes to the same."'/>
                              </span>
                              <p class="personalfile_data" v-if="empInfo.SecondaryPhoneNo != null && empInfo.SecondaryPhoneNo != ''" :title="empInfo.SecondaryPhoneNo">{{empInfo.SecondaryPhoneNo}}</p>
                              <p class="personalfile_data" v-else>N/A</p>
                          </div>
                      </div>
                    </div>

                    <div v-else>
                      <div class="row m0">
                        <div class="col-md-3 pL0">
                            <label>Email Address</label>
                            <p class="personalfile_data" v-if="empInfo.EmailId != null && empInfo.EmailId != ''" :title="empInfo.EmailId">{{empInfo.EmailId}}</p>
                            <p class="personalfile_data" v-else>N/A</p>
                        </div>
                        <div class="col-md-3">
                              <label>Phone Number</label>
                              <p class="personalfile_data" v-if="empInfo.PhoneNo != null && empInfo.PhoneNo != ''" :title="empInfo.PhoneNo">{{empInfo.PhoneNo}}</p>
                              <p class="personalfile_data" v-else>N/A</p>
                          </div>
                      </div>
                    </div>

                    <div class="info-block">

                        <div class="row m0">
                            <div class="inner-heading">
                                <h4 >Employment Details</h4>
                                <!-- <h4 v-else>Employment Details</h4> -->
                            </div>
                            <div class="col-md-3 pL0">
                                <label>Employment Type</label>
                                <span v-if="empInfo.EmploymentWorkType != null && empInfo.EmploymentWorkType != 'None'">
                                    <p class="personalfile_data" v-if="empInfo.EmploymentWorkType == 'FullTime'" :title="empInfo.EmploymentWorkType">Full-Time</p>
                                    <p class="personalfile_data" v-else-if="empInfo.EmploymentWorkType == 'PartTime'" :title="empInfo.EmploymentWorkType">Part-Time</p>
                                    <p class="personalfile_data" v-else :title="empInfo.EmploymentWorkType">{{empInfo.EmploymentWorkType}}</p>
                                </span>
                                <span v-else>
                                    <p class="personalfile_data">N/A</p>
                                </span>
                                <span v-if="empInfo.EmployeeEffectiveFromString != null && empInfo.EmployeeEffectiveFromString != ''">
                                    <p class="personalfile_data">Effective From : {{empInfo.EmployeeEffectiveFromString}}</p>
                                </span>
                            </div>
                            <div class="col-md-3" v-if="loggedInUserObj.HireType == 'W2'||loggedInUserObj.HireType == 'None'">
                                <label>Employment/Contract Start Date</label>
                                <p class="personalfile_data" v-if="empInfo.EmployementStartDateString != null && empInfo.EmployementStartDateString != '' && empInfo.EmployementStartDateString != '0001/01/01T00:00:00'"
                                   :title="empInfo.EmployementStartDateString">{{empInfo.EmployementStartDateString | formatDate('MM/DD/YYYY')}}</p>
                                <p class="personalfile_data" v-else>N/A</p>
                            </div>
                             <div class="col-md-3" v-else>
                                <label>Employment/Contract Start Date</label>
                                <p class="personalfile_data" v-if="empInfo.CurrentProjectStartDateString != null && empInfo.CurrentProjectStartDateString != '' && empInfo.CurrentProjectStartDateString != '0001/01/01T00:00:00'"
                                   :title="empInfo.CurrentProjectStartDateString">{{empInfo.CurrentProjectStartDateString | formatDate('MM/DD/YYYY')}}</p>
                                <p class="personalfile_data" v-else>N/A</p>
                            </div>
                            <div class="col-md-3" >
                                <label>Period of Employment/Contract</label>
                                <p style="color:#FF1734" class="personalfile_data" v-if="empInfo.YearsOfEmployement != null && empInfo.YearsOfEmployement != '' && empInfo.YearsOfEmployement == 'Not Started'" :title="empInfo.YearsOfEmployement">{{empInfo.YearsOfEmployement}}</p>
                                <p class="personalfile_data" v-else-if="empInfo.YearsOfEmployement != null && empInfo.YearsOfEmployement != ''" :title="empInfo.YearsOfEmployement">{{empInfo.YearsOfEmployement}}</p>
                                <p class="personalfile_data" v-else>N/A</p>
                            </div>
                             <!-- <div class="col-md-3" v-else>
                                <label>Period of Employment/Contract2</label>
                                <p style="color:#FF1734" class="personalfile_data" v-if="empInfo.YearsOfEmployement != null && empInfo.YearsOfEmployement != '' && empInfo.YearsOfEmployement == 'Not Started'" :title="empInfo.YearsOfEmployement">{{empInfo.YearsOfEmployement}}</p>
                                <p class="personalfile_data" v-else-if="empInfo.YearsOfEmployement != null && empInfo.YearsOfEmployement != ''" :title="empInfo.YearsOfEmployement">{{empInfo.YearsOfEmployement}}</p>
                                <p class="personalfile_data" v-else>N/A</p>
                            </div> -->
                            <div class="col-md-3" >
                                <label>Employee ID</label>
                                <p class="personalfile_data" v-if="empInfo.EmployeeId != null && empInfo.EmployeeId != ''" :title="empInfo.EmployeeId">{{empInfo.EmployeeId}}</p>
                                <p class="personalfile_data" v-else>N/A</p>
                            </div>
                        </div>
                        <div class="row m0" style="padding-top:10px; padding-bottom: 10px;">
                            <!-- <div class="col-md-3 pL0 " v-if="loggedInUserObj.HireType != 'W2'">
                                <label>Work Authorization Type</label>
                                <p class="personalfile_data" v-if="empInfo.WorkAuthorizationType != null && empInfo.WorkAuthorizationType != ''" :title="empInfo.WorkAuthorizationType">{{empInfo.WorkAuthorizationType}}</p>
                                <p class="personalfile_data" v-else>N/A</p>
                            </div> -->
                            <div class="col-md-3" :class="{'pL0':!loggedInUserObj.HireType != 'W2'}"  v-show="!disableSalaryField">
                                <label>Wage Rate (Offered salary)</label>
                                <p class="personalfile_data">{{getFormattedSalary("W2", WorkPermit, empInfo.MinWageRate, empInfo.MaxWageRate, getWageTypeById(empInfo.WageType), empInfo.IsPaid)}}</p>
                                <span v-if="empInfo.WageEffectiveFromString != null && empInfo.WageEffectiveFromString != ''">
                                    <p class="personalfile_data">Effective From : {{empInfo.WageEffectiveFromString}}</p>
                                </span>
                            </div>
                             <div class="col-md-3">
                                <label>Department</label>
                                <p class="personalfile_data" v-if="empInfo.Department && empInfo.Department.Name != null && empInfo.Department.Name != ''" :title="empInfo.Department.Name">{{empInfo.Department.Name}}</p>
                                <p class="personalfile_data" v-else>N/A</p>
                            </div>
                            <div class="col-md-3">
                                <label>Benefits Status</label>
                                <span v-if="empInfo.CurrentBenefitsStatus != null && empInfo.CurrentBenefitsStatus != '' && empInfo.CurrentBenefitsStatus != 'None'">
                                    <p class="personalfile_data" v-if="empInfo.CurrentBenefitsStatus == 'NotApplicable'">Not Applicable</p>
                                    <p class="personalfile_data" v-else>{{empInfo.CurrentBenefitsStatus}}</p>
                                </span>
                                <span v-else>
                                    <p class="personalfile_data">N/A</p>
                                </span>
                                <span v-if="empInfo.BenefitsEffectiveFromString != null && empInfo.BenefitsEffectiveFromString != ''">
                                    <p class="personalfile_data">
                                        <i>
                                            <span v-if="empInfo.IsDiffInBenefitsStatus">
                                                <span v-if="empInfo.CurrentBenefitsStatus == 'Applicable'">
                                                    "Not Applicable"
                                                </span>
                                                <span v-if="empInfo.CurrentBenefitsStatus == 'NotApplicable'">
                                                    "Applicable"
                                                </span>
                                            </span>
                                            <span :title="empInfo.BenefitsEffectiveFromString">
                                                Effective From:{{empInfo.BenefitsEffectiveFromString}}
                                            </span>
                                        </i>
                                    </p>
                                </span>
                            </div>
                            <div class="col-md-3" v-if="empInfo.CurrentBenefitsStatus == 'Applicable'">
                                <label class="benfitdata">Benefits Type</label>
                                <template v-if="empInfo.BenifitsValue.length > 0">
                                    <template v-for="(b,index) in empInfo.BenifitsValue">
                                        <span class="personalfile_data" v-bind:key="index">
                                            {{b}}
                                            <template v-if="index + 1 < empInfo.BenifitsValue.length">
                                                ,
                                            </template>
                                        </span>
                                    </template>
                                </template>
                                <span v-else class="personalfile_data">N/A</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="update-info">
                    <div class="row m0">
                        <div class="col-md-12 section-personal">
                            <div class="row m0">
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>First Name</label>
                                        <ob-input disabled v-model.trim="empInfo.FirstName"
                                                  placeholder="First Name"></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Middle Name</label>
                                        <ob-input disabled v-model.trim="empInfo.MiddleName" placeholder="Middle Name" ></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Last Name</label>
                                        <ob-input disabled v-model.trim="empInfo.LastName"
                                                  placeholder="Last Name"></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Designation</label>
                                        <ob-input disabled v-model.trim="empInfo.Designation" placeholder="Designation"></ob-input>
                                    </div>
                                </div>
                            </div>
                            <div class="row m0">
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>Email ID</label>
                                        <ob-input v-model.trim="empInfo.EmailId" disabled placeholder="Email ID"></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Phone Number<span class="rcss-text-red">*</span></label>
                                         <ob-input v-phone-number v-model.trim="empInfo.PhoneNo" placeholder="Phone Number" :class="{'ob-vuelidate_input-error' : $v.empInfo.PhoneNo.$error}"></ob-input>
                                                <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.PhoneNo.$dirty && !$v.empInfo.PhoneNo.required">Please enter phone number</span>
                                               <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.PhoneNo.$dirty && !$v.empInfo.PhoneNo.phoneNumber && $v.empInfo.PhoneNo.required">Please enter valid phone number</span>
                                               <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.PhoneNo.$dirty && !$v.empInfo.PhoneNo.maxLength && $v.empInfo.PhoneNo.phoneNumber">Please enter valid phone number</span>
                                               <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.PhoneNo.$dirty && !$v.empInfo.PhoneNo.minLength && $v.empInfo.PhoneNo.phoneNumber ">Please enter valid phone number</span>
                                    </div>
                                </div>
                                <div class="col-md-6 pR0">
                                    <div class="form-group gender-options">
                                        <label>Gender</label>
                                        <div class="radio-inline">
                                            <ob-radio  v-model="empInfo.Gender" val="Male">Male</ob-radio>
                                        </div>
                                        <div class="radio-inline">
                                            <ob-radio  v-model="empInfo.Gender" val="Female">Female</ob-radio>
                                        </div>
                                        <div class="radio-inline">
                                            <ob-radio  v-model="empInfo.Gender" val="Not Disclosed">I choose not to disclose</ob-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m0">
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>Date of Birth</label>
                                        <ob-date-time-picker id="dob" placeholder="Date of Birth" :options="options1" :inputvalue="formatDOB" @updated="(v) => this.empInfo.DOBString = v" v-model.trim="empInfo.DOBString"></ob-date-time-picker>
                                    </div>
                                </div>

                            </div>
                            <div class="row m0"   >
                                <div class="col-md-4 pL0">
                                    <div class="form-group">
                                        <label>Ethnicity</label>
                                        <ob-select2 v-if="ethinicityList.data.length > 0" v-model.trim="empInfo.Ethinicity" :options="ethinicityList"></ob-select2>
                                    </div>
                                </div>
                                <div class="col-md-4 ">
                                    <div class="form-group">
                                        <label>Veteran Status</label>
                                        <ob-select2 v-if="veteranList.data.length > 0" :options="veteranList" v-model.trim="empInfo.VeteranStatus"></ob-select2>
                                    </div>
                                </div>
                            </div>



                            <!--col-md-12-->
                        </div>

                        <!--row-->

                    </div>
                    <div class="row m0">
                        <div class="col-md-12 section-personal">
                            <h4>Current Home Address</h4>
                            <div class="row m0">
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>Address Line 1</label>
                                        <ob-input v-model.trim="empInfo.Address.Address1" placeholder="Address Line 1"></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group">
                                        <label>Address Line 2</label>
                                        <ob-input v-model.trim="empInfo.Address.Address2" placeholder="Address Line 2"></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group">
                                        <label>City, State</label>
                                        <location-search :vmodelData.sync="empInfo.Address.AddressSummary" @input="getZipCode(empInfo)"></location-search>
                                    </div>
                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group">
                                        <label>Zip code</label>
                                        <ob-input placeholder="Zip code" v-model.trim="empInfo.Address.ZipCode" :maxLength="5" v-number-only></ob-input>
                                    </div>
                                </div>
                            </div>
                             <div class="row">
                                <div class="col-md-6 form-group ">
                                <div class="col-md-6 pL0" style="padding-right:5px;">
                                    <label>Period of Stay (From)</label>
                                    <ob-date-time-picker ref="stayFromDate" v-model ="empInfo.Address.PeriodOfStayFrom" class="offer-input" id="stayFromDate" placeholder="From date" :inputvalue="empInfo.Address.PeriodOfStayFrom" :options="datePickerOptions" @updated="(v) => empInfo.Address.PeriodOfStayFrom = v" :dpchange="onCreatedFrom"></ob-date-time-picker>
                                </div>
                                <div class="col-md-6 ">
                                    <label>Period of Stay (To)</label>
                                    <ob-date-time-picker ref="stayToDate" class="offer-input" v-model ="empInfo.Address.PeriodOfStayTo" id="stayToDate" placeholder="To date" :inputvalue="empInfo.Address.PeriodOfStayTo" :options="datePickerOptions" @updated="(v) => empInfo.Address.PeriodOfStayTo = v"></ob-date-time-picker>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row m0">
                        <div class="col-md-12 section-personal">
                            <h4 >Employment Details</h4>
                            <!-- <h4 v-else>Contract Details</h4> -->
                            <div class="row m0">
                                <div class="col-md-3 pL0" >
                                    <div class="form-group">
                                        <label>Employee ID</label>
                                        <ob-input disabled v-model.trim="empInfo.EmployeeId" placeholder="Employee Id"></ob-input>
                                    </div>
                                </div>
                                <!-- <div class="col-md-3 pL0" v-if="loggedInUserObj.HireType != 'W2'">
                                    <div class="form-group">
                                        <label>Work Authorization Type</label>
                                        <ob-input disabled v-model.trim="empInfo.WorkAuthorizationType" placeholder="N/A"></ob-input>
                                    </div>
                                </div> -->
                                <div class="col-md-3" v-if="loggedInUserObj.HireType == 'W2'||loggedInUserObj.HireType =='None'">
                                    <div class="form-group">
                                        <label>Employment/Contract Start Date</label>
                                        <ob-date-time-picker  :inputvalue="formatEmpStartDate"
                                                             :disabled="isDisabled" :options="options" @updated="changeEmpPeriod" v-model.trim="empInfo.EmployementStartDate"></ob-date-time-picker>
                                    </div>
                                </div>
                                 <div class="col-md-3" v-else>
                                    <div class="form-group">
                                        <label>Employment/Contract Start Date</label>
                                        <ob-date-time-picker id="esd" :inputvalue="formatProjectStartDate"
                                                             :disabled="isDisabled" :options="options" @updated="changeContractPeriod" v-model.trim="empInfo.CurrentProjectStartDate"></ob-date-time-picker>
                                    </div>
                                </div>
                                <div class="col-md-3" >
                                    <div class="form-group">
                                        <label>Period of Employment/Contract</label>
                                        <ob-input disabled v-model="empInfo.YearsOfEmployement" placeholder="Employment Period"></ob-input>
                                    </div>
                                </div>
                                <!-- <div class="col-md-3" v-else>
                                    <div class="form-group">
                                        <label>Period of Employment/Contract</label>
                                        <ob-input disabled v-model="empInfo.YearsOfEmployement" placeholder="Employment Period"></ob-input>
                                    </div>
                                </div> -->
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>Department</label>
                                        <ob-input disabled v-model.trim="departmentName" placeholder="N/A"></ob-input>
                                    </div>
                                </div>
                            </div>
                            <div class="row m0">
                                <div class="col-md-3 pL0" >
                                    <div class="form-group">
                                        <label>Wage Rate (Offered salary)</label>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <ob-input icon="fa-usd" disabled :maxLength="10" v-decimal-numbers  v-model="empInfo.MinWageRate" placeholder="From"></ob-input>
                                                </div>
                                                <div class="col-md-6">
                                                    <ob-input icon="fa-usd" disabled :maxLength="10" v-decimal-numbers :class="{ 'ob-vuelidate_input-error': $v.empInfo.MaxWageRate.$error }" v-model="empInfo.MaxWageRate" placeholder="To"></ob-input>
                                                </div>
                                            </div>

                                    </div>
                                </div>
                                <!-- <div class="col-md-6 pL0"  >
                                    <div class="form-group">
                                        <label>Wage Rate (Offered salary)</label>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <ob-input icon="fa-usd" disabled :maxLength="10" v-decimal-numbers  v-model="empInfo.MinWageRate" placeholder="From"></ob-input>
                                                </div>
                                            </div>

                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <h4 class="remove-header section-personal border-0 mB0" style="padding: 10px 0" v-if="empInfo.Depandants.length < 2 " >Dependent Details </h4>
                    <div class="row m0" v-for="(d,index) in empInfo.Depandants"  :key="index">
                        <div class="col-md-12 section-personal border-0 p0">

                            <h4 class="remove-header mB0" style="padding: 10px 0" v-if="empInfo.Depandants.length > 1">Dependent Details {{index+1}}</h4>
                            <a href="javascript:;" class="remove-color" type="link" @click="removeDependent(index)" :class="{'remove-emptycount':empInfo.Depandants.length < 2}">Remove Dependent</a>
                            <div class="row m0">
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>Dependent Type</label>
                                        <ob-select2 v-if="dependantTypeList.data.length > 0" :options="dependantTypeList" v-model.trim="d.DependantType"></ob-select2>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].DependantType.$dirty && !$v.empInfo.Depandants.$each[index].DependantType.requiredIf">Please select benefits</span>
                                    </div>

                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group">
                                        <label>First Name</label>
                                        <ob-input placeholder="First Name" v-formi9-name v-model.trim="d.FirstName" :class="{ 'ob-vuelidate_input-error': $v.empInfo.Depandants.$each[index].FirstName.$error }" @input="updateValue('firstName', d.FirstName, index)"></ob-input>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].FirstName.$dirty && !$v.empInfo.Depandants.$each[index].FirstName.requiredIf">Please enter First name</span>
                                        <!-- <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].FirstName.$dirty && !$v.empInfo.Depandants.$each[index].FirstName.alphawithspace">Please enter alphabets only</span> -->
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].FirstName.$dirty && !$v.empInfo.Depandants.$each[index].FirstName.maxLength && $v.empInfo.Depandants.$each[index].FirstName.alpha">Please enter 150 characters only</span>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].FirstName.$dirty &&  !$v.empInfo.Depandants.$each[index].FirstName.alpha && !$v.empInfo.Depandants.$each[index].FirstName.letterCount">Each word can have a maximum of 100 characters only.</span>

                                    </div>

                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group">
                                        <label>Last Name</label>
                                        <ob-input placeholder="Last Name" v-formi9-name v-model.trim="d.LastName" :class="{ 'ob-vuelidate_input-error': $v.empInfo.Depandants.$each[index].LastName.$error }" @input="updateValue('lastName', d.LastName, index)"></ob-input>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].LastName.$dirty && !$v.empInfo.Depandants.$each[index].LastName.requiredIf">Please enter Last name</span>
                                        <!-- <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].LastName.$dirty && !$v.empInfo.Depandants.$each[index].LastName.alphawithspace">Please enter alphabets only</span> -->
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].LastName.$dirty && !$v.empInfo.Depandants.$each[index].LastName.maxLength && $v.empInfo.Depandants.$each[index].LastName.alpha">Please enter 150 characters only</span>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].LastName.$dirty &&  !$v.empInfo.Depandants.$each[index].LastName.alpha && !$v.empInfo.Depandants.$each[index].LastName.letterCount">Each word can have a maximum of 100 characters only.</span>
                                    </div>

                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <ob-input placeholder="Email" v-model.trim="d.Email" :class="{ 'ob-vuelidate_input-error': $v.empInfo.Depandants.$each[index].Email.$error }"></ob-input>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].Email.$dirty && !$v.empInfo.Depandants.$each[index].Email.email">Please enter valid email</span>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].Email.$dirty && !$v.empInfo.Depandants.$each[index].Email.maxLength && $v.empInfo.Depandants.$each[index].Email.alpha">Please enter 150 characters only</span>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].Email.$dirty &&  !$v.empInfo.Depandants.$each[index].Email.alpha && !$v.empInfo.Depandants.$each[index].Email.letterCount">Each word can have a maximum of 100 characters only.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row m0">
                                <div class="col-md-3 pL0">
                                    <div class="form-group">
                                        <label>Phone Number</label>
                                        <ob-input placeholder="Phone" v-number-only v-model.trim="d.MobileNo"></ob-input>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Visa Status</label>
                                        <ob-select2 v-if="visaList.data.length > 0" :options="visaList" :class="{ 'ob-vuelidate_input-error': $v.empInfo.Depandants.$each[index].VisaStatus.$error }" v-model.trim="d.VisaStatus"></ob-select2>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.empInfo.Depandants.$each[index].VisaStatus.$dirty && !$v.empInfo.Depandants.$each[index].VisaStatus.requiredIf">Please select visa status</span>

                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Benefits</label>
                                        <ob-select2 v-if="benifitsList.data.length > 0" :options="benifitsList" :multiple="true" v-model.trim="d.Benifits"></ob-select2>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                    <div class="add-work-new" > <a href="javascript:;" class="mL0" @click="addDependent()">Add Another Dependent</a> </div>


                    <div style="display:inline-block;width:100%;text-align:left;padding:15px 0;">
                        <ob-button type="secondary" @click="updateCancel">Cancel</ob-button>
                        <ob-button type="primary" @click="updateInfo()" :disabled="isSending" ref="updatebtn">Update</ob-button>
                    </div>
                </div>
                <template v-if="!updateFlag && empInfo.Depandants && empInfo.Depandants.length > 0 ">
                    <div class="info-block">
                        <div v-for="(d,index) in empInfo.Depandants" :key="index">

                            <div class="row m0">
                                <div class="inner-heading">
                                    <h4 v-if="empInfo.Depandants.length <= 1">Dependent Details</h4>
                                    <h4 v-else>Dependent Details {{index+1}}</h4>
                                </div>
                                <div class="col-md-3 pL0 ">
                                    <label>Dependent Type</label>
                                    <span class="deptype-data" v-if="d.DependantType != null && d.DependantType != ''" :title="d.DependantType">{{d.DependantType}}</span>
                                    <span class="deptype-data" v-else>N/A</span>
                                </div>
                                <div class="col-md-3">
                                    <label>Dependent Full Name</label>
                                    <span class="deptype-data" v-if="d.Contact.FirstName != null && d.Contact.LastName != ''">{{d.Contact.FirstName}} {{d.Contact.LastName}}</span>
                                    <span class="deptype-data" v-else>N/A</span>
                                </div>
                                <div class="col-md-3">
                                    <label>Email</label>
                                    <span class="deptype-data" v-if="d.Contact.Email != null && d.Contact.Email != ''" :title="d.Contact.Email">{{d.Contact.Email}}</span>
                                    <span class="deptype-data" v-else>N/A</span>
                                </div>
                                <div class="col-md-3">
                                    <label>Phone Number</label>
                                    <span class="deptype-data" v-if="d.Contact.MobileNo != null && d.Contact.MobileNo != ''" :title="d.Contact.MobileNo">{{d.Contact.MobileNo}}</span>
                                    <span class="deptype-data" v-else>N/A</span>
                                </div>

                            </div>

                            <div class="row m0" style="padding-top:10px;">
                                <div class="col-md-3 pL0">
                                    <label>Visa Status</label>
                                    <span class="deptype-data" v-if="d.VisaStatus != null && d.VisaStatus != ''" :title="d.VisaStatus">{{d.VisaStatus}}</span>
                                    <span class="deptype-data" v-else>N/A</span>
                                </div>
                                <div class="col-md-3">
                                    <label class="benfitdata">Benefits</label>
                                    <template v-if="d.Benifits && d.Benifits.length > 0">
                                        <template v-for="(b,index) in d.Benifits">
                                            <span class="personalfile_data" v-bind:key="index">
                                                {{ b == 'K401' ? '401K' : b}}
                                                <template v-if="index + 1 < d.Benifits.length">
                                                    ,
                                                </template>
                                            </span>
                                        </template>
                                    </template>
                                    <span v-else class="personalfile_data">N/A</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                 <div class="row m0 info-block">
                        <div class="inner-heading">
                            <h4>Current Home Address</h4>
                        </div>
                        <div class="col-md-3 pL0 ">
                            <label>Address Line 1</label>
                            <p class="personalfile_data_address" v-if="empInfo.Address.Address1 != null && empInfo.Address.Address1 != ''">{{empInfo.Address.Address1}}</p>
                            <p class="personalfile_data_address" v-else>N/A</p>
                        </div>
                        <div class="col-md-3 ">
                            <label>Address Line 2</label>
                            <p class="personalfile_data_address" v-if="empInfo.Address.Address2 != null && empInfo.Address.Address2 != ''">{{empInfo.Address.Address2}}</p>
                            <p class="personalfile_data_address" v-else>N/A</p>
                        </div>
                        <div class="col-md-2 ">
                            <label>City, State</label>
                            <p class="personalfile_data_address" v-if="empInfo.Address.AddressSummary != '' && empInfo.Address.AddressSummary != ',' && empInfo.Address.AddressSummary != null">{{empInfo.Address.AddressSummary}}</p>
                            <p class="personalfile_data_address" v-else>N/A</p>
                        </div>
                        <div class="col-md-2 ">
                            <label>ZipCode</label>
                            <p class="personalfile_data_address" v-if="empInfo.Address.ZipCode != null && empInfo.Address.ZipCode != ''">{{empInfo.Address.ZipCode}}</p>
                            <p class="personalfile_data_address" v-else>N/A</p>
                        </div>
                        <div class="col-md-2">
                            <label>Period of stay</label>
                            <p class="personalfile_data_address" style="width: fit-content;" v-if="empInfo.Address.PeriodOfStayFrom != null && empInfo.Address.PeriodOfStayFrom != '' && empInfo.Address.PeriodOfStayTo != null && empInfo.Address.PeriodOfStayTo != ''" :title="'from' + empInfo.Address.PeriodOfStayFrom+' to '+empInfo.Address.PeriodOfStayTo">{{"from " + empInfo.Address.PeriodOfStayFrom +" to "+ empInfo.Address.PeriodOfStayTo}}</p>
                            <p class="personalfile_data_address" style="width: fit-content;" v-else-if ="empInfo.Address.PeriodOfStayFrom != null && empInfo.Address.PeriodOfStayFrom != '' && empInfo.Address.PeriodOfStayTo != null || empInfo.Address.PeriodOfStayTo != ''" :title="'from' + empInfo.Address.PeriodOfStayFrom+' to '+'N/A'">{{"from " +empInfo.Address.PeriodOfStayFrom +" to " + " N/A" }}</p>
                            <p class="personalfile_data_address" v-else>N/A</p>
                        </div>

                    </div>
            </template>
                <template>
                     <div  v-if="isPrevious"  class="row m0 info-block">
						<div class="inner-heading" style="padding-bottom:0px">
							<h4 class="col-md-6 pL0">Previous Home Address</h4>
                             <div class="col-md-6 text-right pL0">
                                <a style="cursor:pointer" @click="addAddress">
                                <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`"/>
                                <span style="color: #000000;font-weight: 600;font-size: 12px;">
                                Add Home Address
                                </span>
                                </a>
                            </div>
						</div>
                          <template v-if="empInfo != null">
                        <div class="row emergency_info" v-for="(data,index) in empInfo.PreviousAddress">
						<div class="col-md-2 pL0 personalfile-details">
							<label>Address Line 1</label>
							<p class="personalfile_data_address" v-if="data.Address1 != null && data.Address1 != ''">{{data.Address1}}</p>
							<p class="personalfile_data_address" v-else>N/A</p>
						</div>
						<div class="col-md-2 personalfile-address">
							<label>Address Line 2</label>
							<p class="personalfile_data_address" v-if="data.Address2 != null && data.Address2 != ''">{{data.Address2}}</p>
							<p class="personalfile_data_address" v-else>N/A</p>
						</div>
						<div class="col-md-2 personalfile-address">
							<label>City, State</label>
							<p class="personalfile_data_address" v-if="data.AddressSummary != '' && data.AddressSummary != null &&  data.AddressSummary !=','">{{data.AddressSummary}}</p>
                            <p class="personalfile_data_address" v-else>N/A</p>
						</div>
						<div class="col-md-2 personalfile-address">
							<label>ZIP Code</label>
							<p class="personalfile_data_address" v-if="data.ZipCode != null && data.ZipCode != ''">{{data.ZipCode}}</p>
							<p class="personalfile_data_address" v-else>N/A</p>
						</div>
                        <div class="col-md-2 personalfile-address">
							<label>Period of stay</label>
							<p class="personalfile_data_address" style="width: fit-content;" v-if="data.PeriodOfStayFrom != null && data.PeriodOfStayFrom != '' &data.PeriodOfStayTo != null && data.PeriodOfStayTo != ''" :title="'from' + data.PeriodOfStayFrom+' to '+data.PeriodOfStayTo">{{"from " + data.PeriodOfStayFrom +" to "+ data.PeriodOfStayTo}}</p>
							<p class="personalfile_data_address" v-else>N/A</p>
						</div>
                         <div class="col-md-2 text-right personalfile-address">
							<a @click="deletePreviousContact(data.Id)" class="action_delete">Remove</a> | <a class="action_update" @click="editAddress(data)">Update</a>
						</div>
                      </div>
                    </template>
					</div>
                  </template>
                     <div v-if="isEmergencyContact" class="row m0 info-block">
						<div class="inner-heading" style="padding-bottom:0px">
							<h4 class="col-md-6 pL0">Emergency Contact Information</h4>
                             <div class="col-md-6 text-right pL0">
                                <a style="cursor:pointer" @click="addContact">
                                <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`"/>
                                <span style="color: #000000;font-weight: 600;font-size: 12px;">
                                Add New Contact
                                </span>
                                </a>
                            </div>
						</div>
                        <template v-if="empInfo != null">
                         <div  class="row emergency_info" v-for="(data,index) in empInfo.EmergencyContact">
                            <div class="col-md-2 pL0 personalfile-details">
                                <label>Contact Name</label>
                                <p class="personalfile_data" v-if="data.Name != null && data.Name != ''" :title="data.Name">{{data.Name}}</p>
                                <p class="personalfile_data" v-else>N/A</p>
                            </div>
                            <div class="col-md-2 personalfile-address">
                                <label>Phone Number</label>
                                <p class="personalfile_data" v-if="data.PhoneNumber != null && data.PhoneNumber != ''" :title="data.PhoneNumber">{{data.PhoneNumber}}</p>
                                <p class="personalfile_data" v-else>N/A</p>
                            </div>
                            <div class="col-md-2 personalfile-address">
                                <label>Email Address</label>
                                <p class="personalfile_data" v-if="data.Email != null && data.Email != ''" :title="data.Email">{{data.Email}}</p>
                                <p class="personalfile_data" v-else>N/A</p>
                            </div>
                            <div class="col-md-2 personalfile-address">
                                <label>Relationship</label>
                                <p class="personalfile_data" v-if="data.RelationShip != null && data.RelationShip != ''" :title="data.RelationShip">{{data.RelationShip}}</p>
                                <p class="personalfile_data" v-else>N/A</p>
                            </div>
                            <div class="col-md-4 text-right personalfile-address">
                                <a @click="deleteEmergencyContact(data.Id)" class="action_delete">Remove</a> | <a class="action_update" @click="editContact(data)">Update</a>
                            </div>
                         </div>
                        </template>
					</div>
                     <div class="row m0 info-block" v-if="empInfo.WorkLocationAddress != null ">
                        <div class="col-md-12 pL0">
						<div class="inner-heading">
							<h4>Current Work Location {{getWorkLocationTypeName()}}</h4>
						</div>
						<div class="col-md-3 pL0 personalfile-details">
							<label>Address Line 1</label>
							<p class="personalfile_data_address" v-if="empInfo.WorkLocationAddress.Address1 != null && empInfo.WorkLocationAddress.Address1 != ''">{{empInfo.WorkLocationAddress.Address1}}</p>
							<p class="personalfile_data_address" v-else>N/A</p>
						</div>
						<div class="col-md-3 personalfile-address">
							<label>Address Line 2</label>
							<p class="personalfile_data_address" v-if="empInfo.WorkLocationAddress.Address2 != null && empInfo.WorkLocationAddress.Address2 != ''">{{empInfo.WorkLocationAddress.Address2}}</p>
							<p class="personalfile_data_address" v-else>N/A</p>
						</div>
						<div class="col-md-3 personalfile-address">
							<label>City, State</label>
							<p class="personalfile_data_address" v-if="empInfo.WorkLocationAddress.AddressSummary != '' && empInfo.WorkLocationAddress.AddressSummary != ',' && empInfo.WorkLocationAddress.AddressSummary != null">{{empInfo.WorkLocationAddress.AddressSummary}}</p>
                            <p class="personalfile_data_address" v-else>N/A</p>
						</div>
						<div class="col-md-3 personalfile-address">
							<label>ZIP Code</label>
							<p class="personalfile_data_address" v-if="empInfo.WorkLocationAddress.ZipCode != null && empInfo.WorkLocationAddress.ZipCode != ''">{{empInfo.WorkLocationAddress.ZipCode}}</p>
							<p class="personalfile_data_address" v-else>N/A</p>
						</div>
                         <!-- <div class="col-md-3 text-right personalfile-address pR0">
							<a @click="deleteWorkLocationAddr()" class="action_delete" >Remove</a> | <a class="action_update" @click="UpdateWorkLocationAddr()" >Update</a>
						</div> -->
                        </div>
					</div>

            <div class="col-md-12 pL0" style="padding-top:15px">
                <div v-if="!isEmergencyContact" class="col-md-3 pL0">
                    <a style="cursor:pointer" @click="addContact">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`"/>
                    <span style="color: #000000;font-weight: 600;font-size: 12px;">
                    Add Emergency Contact
                    </span>
                    </a>
                </div>
                <div v-if="!isPrevious" class="col-md-9 pL0">
                    <a style="cursor:pointer" @click="addAddress">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`"/>
                    <span style="color: #000000;font-weight: 600;font-size: 12px;">
                    Add Home Address
                    </span>
                    </a>
                </div>
            </div>
             <Add-emergency-contact :EmpId="loggedInUserObj.empId"  :IsEdit="isContactEdit" :PreviousData ="contactpreviousData" @close="openEmergencyContactPopup=false" :openModal.sync="openEmergencyContactPopup"></Add-emergency-contact>
             <Add-Home-contact :key="previousData.Id" :EmpId="loggedInUserObj.empId" :IsEdit ="isHomeEdit" :PreviousData ="previousData"  :openModal.sync="openHomeContactPopup"></Add-Home-contact>
             <update-emp-details :empData.sync="empInfo" :openModal.sync="openUpdateEmpPopup"></update-emp-details>
             <br>
             <br v-if="!isEmergencyContact || !isPrevious">
            <!-- Current Work Authorization Documents -->
             <!-- <div v-if="currentDocuments && currentDocuments.length > 0">
                 <h4 style="font-weight: 600; color: #143361;">Work Authorization Document</h4>
                <div v-for="(currDocs, index) in currentDocuments" :key="index" >
                    <div v-if="isMetaDataExists(currDocs)">
                        <div v-if="currDocs.DocumentType == 'EADCardInfo'">
                            <table width="100%" style="margin-top:15px;" class="clearfix">
                                <tr>
                                    <td style="padding-top:5px;">
                                        <div  style="display: inline-block;border-radius: 30px;font-weight: bold;float:left;
                                                        padding: 5px 10px; border: 1px solid #1dc942;background: #f4fef7;">
                                            <span class="document-list__title">{{currDocs.DisplayName}}</span>
                                            <template>
                                                <span style="background: #a4f3b5;color: #1dc942;padding: 0px 5px;border-radius: 100%;" >&#10003;</span>
                                            </template>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="col-md-12" style="padding:0px;text-align:right;" v-if="isViewDownload(currDocs)">
                                            <ob-dropdown title="Actions">
                                                <ob-dropdown-list-item @click.native="viewDocument(currDocs)">View Document</ob-dropdown-list-item>
                                                <ob-dropdown-list-item @click.native="downloadDocument(currDocs)">Download Document</ob-dropdown-list-item>
                                            </ob-dropdown>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <div class="document-list__body clearfix" v-if="currDocs.MetadataValues && currDocs.MetadataValues.length > 0" style="border-bottom:1px dashed #c2c2c2;padding-bottom:10px;">
                                <div class="col-md-10" style="padding:12px 0px 0px 0px;">
                                    <table width="100%">
                                        <thead style="background: none;">
                                            <tr>
                                                <th v-for="(h, index) in currDocs.Metadata" v-if="h.Key !== 'DocumentUrl' && h.Key !== 'SignedDocumentUrl' && h.Key !== 'Description'" :key="index">
                                                    {{h.DisplayName}}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td v-for="(h, hIndex) in documentsTableData(currDocs)" v-if="h.Key !== 'DocumentUrl' && h.Key !== 'SignedDocumentUrl' && h.Key !== 'Description'" :key="hIndex">
                                                    {{h.Value != null && h.Value != '' ? h.Value : 'N/A' }}
                                                    <span v-if="h.Key == 'Category'" v-tooltip="h.Description"><i class="fa fa-info-circle" aria-hidden="true"></i></span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="currDocs.DocumentType == 'GreenCard' || currDocs.DocumentType == 'USCitizen' || currDocs.DocumentType == 'CPT' ||
                                        currDocs.DocumentType == 'I797B' || currDocs.DocumentType == 'I797A' || currDocs.DocumentType == 'I94' ">
                            <table width="100%" style="margin-top:15px;" class="clearfix">
                                <tr>
                                    <td>
                                        <div  style="display: inline-block;border-radius: 30px;font-weight: bold;float:left;
                                                        padding: 5px 10px; border: 1px solid #1dc942;background: #f4fef7;">
                                            <span class="document-list__title">{{currDocs.DisplayName}}</span>
                                            <template>
                                                <span style="background: #a4f3b5;color: #1dc942;padding: 0px 5px;border-radius: 100%;" >&#10003;</span>
                                            </template>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="col-md-12" style="padding:0px;text-align:right;" v-if="isViewDownload(currDocs)">
                                            <ob-dropdown title="Actions">
                                                <ob-dropdown-list-item @click.native="viewDocument(currDocs)">View Document</ob-dropdown-list-item>
                                                <ob-dropdown-list-item @click.native="downloadDocument(currDocs)">Download Document</ob-dropdown-list-item>
                                            </ob-dropdown>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <div class="document-list__body clearfix" v-if="currDocs.MetadataValues && currDocs.MetadataValues.length > 0" style="border-bottom:1px dashed #c2c2c2;padding-bottom:10px;">
                                <div class="col-md-10" style="padding:12px 0px 0px 0px;">
                                    <table width="100%">
                                        <thead style="background: none;">
                                            <tr>
                                                <th v-for="(h, index) in currDocs.Metadata" v-if="h.Key !== 'DocumentUrl' && h.Key !== 'SignedDocumentUrl' && h.Key !== 'Description'" :key="index">
                                                    {{h.DisplayName}}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td v-for="(h, hIndex) in documentsTableData(currDocs)" v-if="h.Key !== 'DocumentUrl' && h.Key !== 'SignedDocumentUrl' && h.Key !== 'Description'" :key="hIndex">
                                                    {{h.Value != null && h.Value != '' ? h.Value : 'N/A' }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="col-md-12 section" style="padding-top: 10px;padding-left:0px;border-bottom:1px dashed #c2c2c2">
                            <table width="100%" style="margin-bottom: 10px;">
                                <tr>
                                    <td style="padding-top:5px;">
                                        <div  style="display: inline-block;border-radius: 30px;font-weight: bold;float:left; padding: 5px 10px; border: 1px solid #c2c2c2;background: #fdfdfd;">
                                            <span class="document-list__title" v-if="currDocs !=null && currDocs.DisplayName !=''" >{{currDocs.DisplayName}}</span>
                                            <template >
                                                <span style="background: #c2c2c2;color: #fdfdfd;padding: 0px 5px;border-radius: 100%;" >?</span>
                                            </template>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- Previous Work Authorization Documents -->
            <div v-if="previousDocs && previousDocs.length > 0" style="margin-top:20px;">
                 <h4 style="font-weight: 600; color: #143361;">Previous Work Auth Documents</h4>
                <div v-for="(previousDocs, index) in previousDocs" :key="index">
                    <div v-if="isMetaDataExists(previousDocs)">
                        <div v-if="previousDocs.DocumentType == 'EADCardInfo'">
                            <table width="100%" style="margin-top:15px;">
                                <tr>
                                    <td style="padding-top:5px;">
                                        <div  style="display: inline-block;border-radius: 30px;font-weight: bold;float:left;
                                        padding: 5px 10px;border:1px solid rgb(194, 194, 194);background: rgb(253, 253, 253);">
                                            <span class="document-list__title">{{previousDocs.DisplayName}}</span>
                                            <template >
                                                <span style="background: rgb(194, 194, 194);color: rgb(253, 253, 253);padding: 0px 5px;border-radius: 100%;" >&#10003;</span>
                                            </template>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="col-md-12" style="padding:0px;text-align:right;" v-if="isViewDownload(previousDocs)">
                                            <ob-dropdown title="Actions">
                                                <ob-dropdown-list-item @click.native="viewDocument(previousDocs)">View Document</ob-dropdown-list-item>
                                                <ob-dropdown-list-item @click.native="downloadDocument(previousDocs)">Download Document</ob-dropdown-list-item>
                                            </ob-dropdown>
                                            </div>
                                    </td>
                                </tr>
                            </table>
                            <div class="document-list__body clearfix"  v-if="previousDocs.MetadataValues && previousDocs.MetadataValues.length > 0" style="border-bottom:1px dashed #c2c2c2;padding-bottom:10px;">
                                <div class="col-md-10" style="padding:12px 0px 0px 0px;">
                                    <table width="100%">
                                        <thead style="background: none;">
                                            <tr>
                                                <th v-for="(h, index) in previousDocs.Metadata" v-if="h.Key !== 'DocumentUrl' && h.Key !== 'SignedDocumentUrl' && h.Key !== 'Description'" :key="index">
                                                    {{h.DisplayName}}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td v-for="(h, hIndex) in documentsTableData(previousDocs)" v-if="h.Key !== 'DocumentUrl' && h.Key !== 'SignedDocumentUrl' && h.Key !== 'Description'" :key="hIndex">
                                                    {{h.Value != null && h.Value != '' ? h.Value : 'N/A' }}
                                                    <span v-if="h.Key == 'Category'" v-tooltip="h.Description"><i class="fa fa-info-circle" aria-hidden="true"></i></span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="previousDocs.DocumentType == 'GreenCard' || previousDocs.DocumentType == 'USCitizen' || previousDocs.DocumentType == 'CPT' ||
                                        previousDocs.DocumentType == 'I797B' || previousDocs.DocumentType == 'I797A' || previousDocs.DocumentType == 'I94'">
                            <table width="100%" style="margin-top:15px;">
                                <tr>
                                    <td style="padding-top:5px;">
                                        <div  style="display: inline-block;border-radius: 30px;font-weight: bold;float:left;
                                        padding: 5px 10px;border:1px solid rgb(194, 194, 194);background: rgb(253, 253, 253);">
                                            <span class="document-list__title">{{previousDocs.DisplayName}}</span>
                                            <template >
                                                <span style="background: rgb(194, 194, 194);color: rgb(253, 253, 253);padding: 0px 5px;border-radius: 100%;" >&#10003;</span>
                                            </template>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="col-md-12" style="padding:0px;text-align:right;" v-if="isViewDownload(previousDocs)">
                                            <ob-dropdown title="Actions">
                                                <ob-dropdown-list-item @click.native="viewDocument(previousDocs)">View Document</ob-dropdown-list-item>
                                                <ob-dropdown-list-item @click.native="downloadDocument(previousDocs)">Download Document</ob-dropdown-list-item>
                                            </ob-dropdown>
                                            </div>
                                    </td>
                                </tr>
                            </table>
                            <div class="document-list__body clearfix"  v-if="previousDocs.MetadataValues && previousDocs.MetadataValues.length > 0" style="border-bottom:1px dashed #c2c2c2;padding-bottom:10px;">
                                <div class="col-md-10" style="padding:12px 0px 0px 0px;">
                                    <table width="100%">
                                        <thead style="background: none;">
                                            <tr>
                                                <th v-for="(h, index) in previousDocs.Metadata" v-if="h.Key !== 'DocumentUrl' && h.Key !== 'SignedDocumentUrl' && h.Key !== 'Description'" :key="index">
                                                    {{h.DisplayName}}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td v-for="(h, hIndex) in documentsTableData(previousDocs)" v-if="h.Key !== 'DocumentUrl' && h.Key !== 'SignedDocumentUrl' && h.Key !== 'Description'" :key="hIndex">
                                                    {{h.Value != null && h.Value != '' ? h.Value : 'N/A' }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="col-md-12 section" style="padding-top: 10px;padding-left:0px;border-bottom:1px dashed #c2c2c2">
                            <table width="100%" style="margin-bottom: 10px;">
                                <tr>
                                    <td >
                                        <div  style="display: inline-block;border-radius: 30px;font-weight: bold;float:left; padding: 5px 10px; border: 1px solid #c2c2c2;background: #fdfdfd;">
                                            <span class="document-list__title" v-if="previousDocs !=null && previousDocs.DisplayName !=''" >{{previousDocs.DisplayName}}</span>
                                            <template >
                                                <span style="background: #c2c2c2;color: #fdfdfd;padding: 0px 5px;border-radius: 100%;" >?</span>
                                            </template>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="documents-block" >
                <custom-collapse GroupId="RightToControlDocuments" From="personnel" FolderHeaderHeading="Right To Control Documents"></custom-collapse>
                <custom-collapse GroupId="FederalW4" From="personnel" FolderHeaderHeading="Federal W4 Form"></custom-collapse>
                <custom-collapse GroupId="Benefits"  From="personnel" FolderHeaderHeading="Benefits" :BenefitsStatus="benefitsStatus" :BenefitsEffectiveFrom="benefitsEffectiveFrom" :BenefitsList="benefitsList"></custom-collapse>
                <custom-collapse GroupId="EducationalAndExperienceDocuments" From="personnel" FolderHeaderHeading="Educational & Experience Documents"></custom-collapse>
                <custom-collapse GroupId="IDProof" From="personnel" FolderHeaderHeading="ID Proofs"></custom-collapse>
                <custom-collapse v-if="this.TaxTerm == 'W2'" GroupId="OrganizationDocuments" From="personnel" FolderHeaderHeading="Organization Documents"></custom-collapse>
            </div>
             <!-- <div class="documents-block" v-if="loggedInUserObj.HireType != 'W2'">
                <custom-collapse GroupId="IDProof" From="personnel" FolderHeaderHeading="ID Proofs"></custom-collapse>
            </div> -->
        </div>
        <div v-if="!isOnboarded" class="no-candidates">
            <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/empty list.png`" />
            <h3>There is no data available</h3>
        </div>
    </div>

</template>

<script>
    import namevalidation from "Vue/Core/namevalidation.js"
    import AddHomeContact from './AddHomeContact'
    import AddEmergencyContact from './AddEmergencyContact'
    import CustomCollapse from './CustomCollapse.vue';
    import utils from '@/components/Core/utils.js'
    import ESSMixin from './ESSMixin.js'
    import UpdateEmpDetails from './UpdateEmpDetails'
    import { required, minLength, maxLength, requiredIf, email, alpha, minValue } from 'vuelidate/lib/validators'
    import { req, withParams } from 'vuelidate/lib/validators/common'
    const DecimalNumber = withParams({ type: 'DecimalNumber' }, value => {
        return !req(value) || /^\d+(\.\d{1,2})?$/.test(value);
    })
    const alphawithspace = (value) => {
        var alsp = /^[a-zA-Z\s]*$/i
        return alsp.test(value)
    }
    const phoneNumber = (value) => {
        var phone = /^[0-9 +()-]+$/i
        return phone.test(value)
    }
    const letterCount = withParams({ type: 'letterCount' }, value => {
        if (value != null && value.length <= 150) {
            var strArr = value.split(" ");
            let error = true;
            strArr.forEach(function (word) {
                if (word.length > 100) {
                    error = false
                    return;
                }
            });
            return !req(value) || error
        }
        else {
            return true
        }

    })
    export default {
        mixins: [ESSMixin],
       // props: ["consultantDetails"],
        data() {
            return {
                benefitsList:[],
                benefitsEffectiveFrom:'',
                benefitsStatus:'',
                isDisabled: true,
                isPrevious :false,
                previousData:'',
                contactpreviousData:'',
                isEmergencyContact:true, // need change when list came
                isHomeEdit : false,
                isContactEdit :false,
                openEmergencyContactPopup:false,
                openHomeContactPopup : false,
                openUpdateEmpPopup :false,
                isSending: false,
                isOnboarded: true,
                rightTCDocs: null,
                memosWarns: null,
                awardsAppre: null,
                federalW4: null,
                benifits: null,
                eduAExp: null,
                rightTCDocsl: null,
                memosWarnsl: null,
                awardsApprel: null,
                federalW4l: null,
                benifitsl: null,
                eduAExpl: null,
                idProofDocsVal :null,
                OrgDocumentsVal: null,
                leavesAVacl: null,
                idProofDoc:null,
                OrgDocument:null,
                updateFlag: false,
                empInfo: {
                    Address: '',
                    Benifits: '',
                    BenifitsList: '',
                    BenifitsValue: '',
                    BillRate: '',
                    Company: "",
                    DOB: "",
                    Designation: '',
                    EmailId: '',
                    EmployementStartDate: '',
                    EmployementStartDateString: '',
                    CurrentProjectStartDateString:'',
                    CurrentProjectStartDate:'',
                    Ethinicity: '',
                    EthinicityList: '',
                    FirstName: '',
                    Gender: '',
                    LastName: '',
                    Location: '',
                    MaxWageRate: '',
                    MiddleName: '',
                    MinWageRate: '',
                    PhoneNo: "",
                    RecruiterEmail: "",
                    RecruiterName: "",
                    Salary: '',
                    VeteranList: '',
                    VeteranStatus: '',
                    VisaList: '',
                    YearsOfEmployement: "",
                    Depandants: [],
                    HireType:'',
                    WorkPermit:'',
                    WorkAuthorizationType:'',
                    EmploymentWorkType:'',
                    BenefitsEffectiveFrom:'',
                    WageEffectiveFrom:'',
                    BenefitsEffectiveFromString:'',
                    WageEffectiveFromString:'',
                    BenefitsStatus:'',
                    EmployeeEffectiveForm:'',
                    EmployeeEffectiveFromString:''
                },
                leavesAVac: null,
                options1: {
                    format: 'MM/DD/YYYY',
                    dayViewHeaderFormat: 'MM/DD/YYYY',
                    maxDate: moment().subtract(15, 'years'),
                    ignoreReadonly: true,
                    widgetPositioning: {
                        horizontal: "auto",
                        vertical: "bottom"
                    }
                },
                datePickerOptions: {
                format: 'MM/DD/YYYY'
                },
                options: {
                    format: 'MM/DD/YYYY',
                    ignoreReadonly: true,
                    widgetPositioning: {
                        horizontal: "auto",
                        vertical: "bottom"
                    }
                },
                deptList: {
                    placeholder: {
                        id: '-1', // the value of the option
                        text: 'Please select'
                    },
                    data: []
                },
                veteranList: {
                    placeholder: {
                        id: '-1', // the value of the option
                        text: 'Please select'
                    },
                    data: []
                },
                ethinicityList: {
                    placeholder: {
                        id: '-1', // the value of the option
                        text: 'Please select'
                    },
                    data: []
                },
                visaList: {
                    placeholder: {
                        id: '-1', // the value of the option
                        text: 'Please select'
                    },
                    data: []
                },
                dependantTypeList: {
                    placeholder: {
                        id: '-1', // the value of the option
                        text: 'Please select'
                    },
                    data: []
                },
                benifitsList: {
                    placeholder: {
                        id: '-1', // the value of the option
                        text: 'Please select'
                    },
                    data: []
                },
                empUpdateDetails: {

                    Id: '',
                    FirstName: '',
                    LastName: '',
                    Gender: '',
                    Ethinicity: '',
                    VeteranStatus: '',
                    DOB: '',
                    EmployeeId: '',
                    Department: '',
                    EmployementStartDate: '',
                    YearsOfEmployement: '',
                    Depandants: '',
                    Benifits: '',
                },
                departmentId:'',
                departmentName:'',
                currentDocuments:[],
                previousDocs:[]

            }
        },
        validations() {
            return {

                empInfo: {
                    "MinWageRate": {
                        DecimalNumber
                    },
                    "MaxWageRate": {
                        DecimalNumber
                    },
                    "PhoneNo":{
                                required,
                                phoneNumber,
                                 maxLength: maxLength(20),
                                  minLength: minLength(10),
                            },
                    "Depandants": {
                        $each: {
                            "DependantType": {
                                requiredIf: requiredIf((d) => {
                                    return d.DependantType != '' && d.DependantType != 'None'
                                })
                            },
                            "FirstName": {
                                requiredIf: requiredIf((d) => {
                                    return d.DependantType != '' && d.DependantType != 'None'
                                }),
                                // alphawithspace,
                                maxLength: maxLength(150),
                                letterCount
                            },
                            "LastName": {
                                requiredIf: requiredIf((d) => {
                                    return d.DependantType != '' && d.DependantType != 'None'
                                }),
                                // alphawithspace,
                                maxLength: maxLength(150),
                                letterCount
                            },
                            "Email": {
                                email,
                                maxLength: maxLength(150),
                                letterCount
                            },
                            "VisaStatus": {
                                requiredIf: requiredIf((d) => {
                                    return d.DependantType != '' && d.DependantType != 'None'
                                })
                            }
                        }
                    }
                }
            }
        },
        components: {
            'custom-collapse' : CustomCollapse,
            'Add-emergency-contact': AddEmergencyContact,
            'Add-Home-contact': AddHomeContact,
            'update-emp-details':UpdateEmpDetails
        },
        computed: {
             consultantDetails: {
                get() {
                    return this.$store.getters.getConsultantDetails;
                },
                set(value) {
                    this.$store.commit("updateConsultantDetails", value);
                }
         },

            disableSalaryField() {
                return this.empInfo.IsPaid == false && (this.WorkPermit == 'OPT EAD' || this.WorkPermit == 'CPT')
            },
            showWageRateInfo() {
                let flag = false
                let WorkPermit = ["New H-1B (CAP Exempt)", "H-1B Amendment", "H-1B Transfer", "H-1B Extension", "New H-1B (CAP)", "H-1B"]
                if (this.TaxTerm == 'W2' && WorkPermit.indexOf(this.WorkPermit) != -1) {
                    flag = true
                }

                return flag
            },
            TaxTerm() {
                if (this.consultantDetails && this.consultantDetails.HireType) {
                    return this.consultantDetails.HireType
                } else {
                    return this.$route.query.tax
                }
            },
            WorkPermit() {
                if (this.consultantDetails && this.consultantDetails.WorkPermit) {
                    return this.consultantDetails.WorkPermit
                } else {
                    return this.$route.query.workpermit
                }
            },
            fullName() {
                return this.empInfo.FirstName + ' ' + this.empInfo.LastName
            },
            jobId() {
                if (this.empInfo && this.empInfo.JobId) {
                    return this.empInfo.JobId
                } else {
                    return ""
                }
            },
            fileUploadUrl() {
                return `/OnBoard/UpdateDocumentByGroup?consultantId=${loggedInUserObj.consultantId}&jobId=${this.jobId}&orgId=${loggedInUserObj.orgId}`
            },
            benifitTypes() {
                if (this.empInfo.BenifitsValue != null && this.empInfo.BenifitsValue.length > 0) {
                    let benifitarry = []
                    this.empInfo.BenifitsValue.forEach((b) => {
                        benifitarry.push({ 'DocumentUrl': null, 'BenifitType': b })
                    })
                    return benifitarry
                }
            },
            formatDOB() {
                if (this.empInfo != null && this.empInfo.DOBString != null && this.empInfo.DOBString != '' && this.empInfo.DOBString != '0001/01/01T00:00:00') {
                    return this.empInfo.DOBString
                }

            },
            formatEmpStartDate() {
                if (this.empInfo != null && this.empInfo.EmployementStartDateString != null && this.empInfo.EmployementStartDateString != '' && this.empInfo.EmployementStartDate != '0001/01/01T00:00:00') {
                    return this.empInfo.EmployementStartDateString
                }

            },
            formatProjectStartDate(){
                if (this.empInfo != null && this.empInfo.CurrentProjectStartDateString != null && this.empInfo.CurrentProjectStartDateString != '' && this.empInfo.CurrentProjectStartDate != '0001/01/01T00:00:00') {
                    return this.empInfo.CurrentProjectStartDateString
                }
            }
        },
        watch: {

        },
        created() {

            this.getEmployeeDatails()
            this.getAllDocuments()
        },
        methods: {
          updateValue(modelName, value, index){
            let val = namevalidation.getValidName(value);
            if(modelName == "firstName")
                this.empInfo.Depandants[index].FirstName = val
            else
                this.empInfo.Depandants[index].LastName = val
          },
            viewDocument(data){

            var docData = data.MetadataValues[0].DocumentData
                let viewdocUrl = ''
                docData.forEach((s) => {
                    if (s.Key == "DocumentUrl") {
                        viewdocUrl = s.Value
                    }
                })
                utils.previewSingleDoc(viewdocUrl)

            },
            isViewDownload(data){
                var docData = data.MetadataValues[0].DocumentData
                let viewdocUrl = ''
                docData.forEach((s) => {
                    if (s.Key == "DocumentUrl") {
                        viewdocUrl = s.Value
                    }
                })
                if(viewdocUrl && viewdocUrl !="" ){
                    return true
                }
                else {
                    return false
                    }
            },
            downloadDocument(data){
            var docData = data.MetadataValues[0].DocumentData
            let downDocUrl = ''
            docData.forEach((s) => {
                if (s.Key == "DocumentUrl") {
                    downDocUrl = s.Value

                }
            })
             utils.downloadSingleDoc(downDocUrl)
          },

             getC2CWorkAuthDocuments(){
                ajax.get(`/Employee/${loggedInUserObj.empId}/GetC2CWorkAuthDocuments`,{},(res) => {
                    if(res.data.State == true){
                        this.WorkAuthDocs = res.data.WorkAuthDocs
                        this.currentDocuments =this.WorkAuthDocs.CurrentDocs
                        this.previousDocs = this.WorkAuthDocs.PreviousDocs
                    }
                    else{
                        this.ESSEnableDisable(res)
                    }

                })
            },
            getWageTypeById(WageType) {
                if(WageType == "None") {
                    return "None"
                }else if(WageType == "Hourly") {
                    return "Hourly"
                } else if(WageType == "Weekly") {
                    return "Weekly"
                } else if(WageType == "BiWeekly") {
                    return "Bi-Weekly"
                } else if(WageType == "Monthly") {
                    return "Monthly"
                } else if(WageType == "SemiMonthly") {
                    return "Semi-Monthly"
                } else if(WageType == "Yearly") {
                    return "Yearly"
                }
            },
            getFormattedSalary(TaxTerms, WorkPermit, MinWageRate, MaxWageRate, WageType, IsPaid) {
                if (TaxTerms == "W2") {

                    let WorkPermits = ["New H-1B (CAP Exempt)", "H-1B Amendment", "H-1B Transfer", "H-1B Extension", "New H-1B (CAP)", "H-1B"]
                    if (WorkPermit == "OPT EAD" || WorkPermit == "CPT") {
                        if (IsPaid == true) {
                            return `$${MinWageRate} / ${WageType}`
                        } else {
                            return "Unpaid"
                        }
                    } else if (WorkPermits.indexOf(WorkPermit) == -1) { // Non H-1B
                        if (MinWageRate > 0) {
                            return `$${MinWageRate} / ${WageType}`
                        } else {
                            return 'N/A'
                        }
                    } else {
                        if (MinWageRate > 0 && MaxWageRate > 0) {
                            return `$${MinWageRate} to $${MaxWageRate} / ${WageType}`
                        } else if (MinWageRate == 0 && MaxWageRate == 0) {
                            return 'N/A'
                        } else if (MinWageRate == 0 && MaxWageRate > 0) {
                            return `$${MaxWageRate} / ${WageType}`
                        } else if (MinWageRate > 0 && MaxWageRate == 0) {
                            return `$${MinWageRate} / ${WageType}`
                        }

                    }
                } else {
                    if (MinWageRate > 0) {
                        return `$${MinWageRate} / ${WageType}`
                    } else {
                        return 'N/A'
                    }
                }
            },
            getAllDocuments() {
                this.setDefaultValues()
                let types = ['RightToControlDocuments', 'FederalW4', 'Benefits', 'EducationalAndExperienceDocuments', 'IDProof', 'OrganizationDocuments']
                //'MemosAndWarnings', 'AwardsAndAppreciation', 'LeavesAndVacations'
                types.forEach((t) => {
                    ajax.get(`/OnBoard/${loggedInUserObj.consultantId}/{}/GetDocumentList?group=${t}&orgId=${this.loggedInUserObj.orgId}&isESS=true`, {}, (res) => {
                        if (res.data.State == true) {

                            if (res.data.GroupId == 'RightToControlDocuments')
                                this.rightTCDocs = res.data,
                                    this.rightTCDocsl = res.data.ListOfDocuments,
                                    this.rightTCDocsl.forEach((d) => {
                                        d.CanESign = true
                                        this.$set(d, 'jobid', this.$route.query.jobId)
                                    })
                            else if (res.data.GroupId == 'FederalW4')
                                this.federalW4 = res.data,
                                    this.federalW4l = res.data.ListOfDocuments,
                                    this.federalW4l.forEach((d) => {
                                        d.CanESign = true
                                        this.$set(d, 'jobid', this.$route.query.jobId)
                                    })
                            else if (res.data.GroupId == 'Benefits')
                                this.benifits = res.data,
                                    this.benifitsl = res.data.ListOfDocuments,
                                    this.benifitsl.forEach((d) => {
                                        d.CanESign = true
                                        this.$set(d, 'jobid', this.$route.query.jobId)
                                    })
                            else if (res.data.GroupId == 'EducationalAndExperienceDocuments')
                                this.eduAExp = res.data,
                                    this.eduAExpl = res.data.ListOfDocuments,
                                    this.eduAExpl.forEach((d) => {
                                        d.CanESign = true
                                        this.$set(d, 'jobid', this.$route.query.jobId)
                                    })
                           else if(res.data.GroupId == 'IDProof')
                                this.idProofDoc = res.data,
                                this.idProofDocsVal = res.data.ListOfDocuments,
                                this.idProofDocsVal.forEach((d) => {
                                    d.CanESign = true
                                    this.$set(d, 'jobid',this.$route.query.jobId)
                            })
                           else if(res.data.GroupId == 'OrganizationDocuments')
                                this.OrgDocument = res.data,
                                this.OrgDocumentsVal = res.data.ListOfDocuments,
                                this.OrgDocumentsVal.forEach((d) => {
                                    d.CanESign = true
                                    this.$set(d, 'jobid',this.$route.query.jobId)
                            })
                        }
                        else{
                            this.ESSEnableDisable(res)
                        }
                    })
                })
            },
            getEmployeeDatails() {
                this.getC2CWorkAuthDocuments();
                //this.$loading({'loadingText': 'Loading...'})${loggedInUserObj.empId}
                this.clearDDValues()
                ajax.get(`/Employee/${loggedInUserObj.empId}/GetEmployeePersonelInfo`, {}, (res) => {

                    if (res.data.State == true && res.data.EmployeeDetail != null) {

                        this.isOnboarded = true
                        let temp = res.data.EmployeeDetail
                        let EmergencyContactList = res.data.EmployeeDetail.EmergencyContact
                        let PrevoiusAddresList  = res.data.EmployeeDetail.PreviousAddress
                        if(EmergencyContactList.length >0) this.isEmergencyContact = true
                        else this.isEmergencyContact = false

                        if(PrevoiusAddresList.length >0 ) this.isPrevious = true
                        else this.isPrevious = false

                        this.$store.commit('updateEmpDetails',temp)
                        temp.DepartmentList.forEach((r) => {
                            this.deptList.data.push({ 'id': r, 'text': r })
                        })
                        temp.EthinicityList.forEach((r) => {
                            this.ethinicityList.data.push({ 'id': r, 'text': r })
                        })
                        temp.VeteranList.forEach((r) => {
                            this.veteranList.data.push({ 'id': r, 'text': r })
                        })
                        temp.VisaList.forEach((r) => {
                            this.visaList.data.push({ 'id': r, 'text': r })
                        })
                        temp.DependantTypeList.forEach((r) => {
                            this.dependantTypeList.data.push({ 'id': r, 'text': r })
                        })

                        temp.BenifitsList.forEach((r) => {
                            let id = r
                            if (r == "401K") {
                                id = "K401"
                            }
                            this.benifitsList.data.push({ 'id': id, 'text': r })
                        })
                        temp.Depandants.forEach((r) => {
                            let benfistemp = []
                            if (r.Benifits != null && r.Benifits.length > 0) {
                                r.Benifits.forEach((f) => {
                                    benfistemp.push(f.BenifitType)
                                })
                                r.Benifits = benfistemp
                            }
                        })

                        if (temp.Depandants && temp.Depandants.length != 0) {

                            temp.Depandants.forEach((r) => {
                                if (r.Contact != null) {
                                    //this.$set(r, 'Name', r.Contact.Name)
                                    this.$set(r, 'Email', r.Contact.Email)
                                    this.$set(r, 'MobileNo', r.Contact.MobileNo)
                                    this.$set(r, 'FirstName', r.Contact.FirstName)
                                    this.$set(r, 'LastName', r.Contact.LastName)
                                    //this.$set(r.Contact, 'DependantType', r.DependantType)
                                }
                            })
                        }
                        this.benefitsList = []
                        temp.BenifitsValue.forEach((v) => {
                            if(v == 'Medical')
                                this.benefitsList.push('Medical Benefits')
                            else if(v == 'Dental')
                                this.benefitsList.push('Dental Benefits')
                            else if(v == 'Vision')
                                this.benefitsList.push('Vision Benefits')
                            else if(v == '401K')
                                this.benefitsList.push('401K')
                            else if(v == 'Life')
                                this.benefitsList.push('Life Benefits')
                        })
                        this.empInfo = temp
                        this.benefitsStatus = this.empInfo.BenefitsStatus
                        this.benefitsEffectiveFrom = this.empInfo.BenefitsEffectiveFromString
                        if(this.empInfo.Department != null){
                            this.departmentId = this.empInfo.Department.Id
                            this.departmentName = this.empInfo.Department.Name
                            }
                            else {
                                this.departmentId = ''
                                this.departmentName = ''
                            }
                        if(loggedInUserObj.HireType == 'W2'||loggedInUserObj.HireType == 'None'){
                            if(this.empInfo.EmployementStartDateString != null && this.empInfo.EmployementStartDateString != ''){
                                //this.changeEmpPeriod(this.empInfo.EmployementStartDate)
                            }
                            else{
                                this.empInfo.YearsOfEmployement = 'Not Started'
                            }
                        }
                        else {
                            if(this.empInfo.CurrentProjectStartDateString != null && this.empInfo.CurrentProjectStartDateString != ''){
                                //this.changeContractPeriod(this.empInfo.CurrentProjectStartDate)
                            }
                            else{
                                this.empInfo.YearsOfEmployement = 'Not Started'
                            }
                        }


                        this.$store.commit('updatePhoneNumber',this.empInfo.PhoneNo)
                        this.$store.commit('updateEmpStartDate', this.empInfo.EmployementStartDateString)

                    }
                    else {
                        this.ESSEnableDisable(res)
                        this.isOnboardred = false
                    }
                    this.$loading({}).close()
                    //  setTimeout(() => {
                    //   //this.scrollTo(document.getElementById('topSections').offsetTop - 0)
                    // //  this.scrollTo(document.getElementById('topSections').offsetTop - 50)
                    // }, 300)
                })
            },


            addDependent() {
                if (this.empInfo.Depandants != null) {
                    this.empInfo.Depandants.length + 1
                } else {
                    this.empInfo.Depandants = []
                }
                let newDependent = {}
                let Contact = { 'Name': '', 'Email': '', 'MobileNo': '' }
                newDependent.Contact = Contact
                newDependent.DependantType = ''
                newDependent.VisaStatus = ''
                newDependent.FirstName = ''
                newDependent.LastName = ''
                newDependent.Email = ''
                newDependent.MobileNo = ''
                newDependent.Benifits = ''
                this.empInfo.Depandants.push(newDependent)
            },
            removeDependent(indexVal) {
                this.empInfo.Depandants.splice(indexVal, 1)
            },
            updateCancel() {
                this.empInfo = null
                this.getEmployeeDatails()
                setTimeout(() => {
                    this.updateFlag = false

                    //  this.scrollTo(document.getElementByClass('personal-main').offsetTop - 50)

                }, 500)
            },
            updateInfo() {

                this.$v.empInfo.$touch();
                if (this.$v.empInfo.$invalid == false) {
                    this.$loading({ 'loadingText': 'Loading...' })
                    let tempDepandants = __.cloneDeep(this.empInfo.Depandants)

                    tempDepandants.forEach((d, i) => {
                        if (d.DependantType != '') {
                            d.Contact.FirstName = d.FirstName
                            d.Contact.LastName = d.LastName
                            d.Contact.Email = d.Email
                            d.Contact.MobileNo = d.MobileNo
                            let tempBenifits = []
                            if (d.Benifits != null && d.Benifits.length > 0) {
                                d.Benifits.forEach((r, i) => {
                                    tempBenifits.push({ "DocumentUrl": '', "BenifitType": r })
                                })
                                d.Benifits = tempBenifits
                            }
                        }
                        if (d.DependantType == '') {
                            this.empInfo.Depandants.splice(i, 1)
                            tempDepandants.splice(i, 1)
                        }
                    })
                    let UpdateDetails = {
                        Id: loggedInUserObj.empId,
                        FirstName: this.empInfo.FirstName,
                        LastName: this.empInfo.LastName,
                        MiddleName: this.empInfo.MiddleName,
                        EmailId: this.empInfo.EmailId,
                        PhoneNo: this.empInfo.PhoneNo,
                        Designation: this.empInfo.Designation,
                        MaxWageRate: this.empInfo.MaxWageRate,
                        MinWageRate: this.empInfo.MinWageRate,
                        Gender: this.empInfo.Gender,
                        Ethinicity: this.empInfo.Ethinicity,
                        VeteranStatus: this.empInfo.VeteranStatus,
                        DOB: this.empInfo.DOBString,
                        EmployeeId: this.empInfo.EmployeeId,
                        YearsOfEmployement: this.empInfo.YearsOfEmployement,
                        Benifits: this.benifitTypes,
                        Address: this.empInfo.Address,
                        Depandants: tempDepandants,
                        WageType: this.empInfo.WageType,
                        IsBilling: this.empInfo.IsBilling,
                        EmploymentWorkType:this.empInfo.EmploymentWorkType,
                        WageEffectiveFrom : this.empInfo.WageEffectiveFrom,
                        BenefitsEffectiveFrom : this.empInfo.BenefitsEffectiveFrom,
                        BenefitsStatus: this.empInfo.BenefitsStatus,
                        EmployeeEffectiveForm : this.empInfo.EmployeeEffectiveForm,
                        HireType :this.empInfo.HireType,
                    }
                    if(loggedInUserObj.HireType == 'W2'||loggedInUserObj.HireType == 'None'){
                        UpdateDetails.EmployementStartDate= this.empInfo.EmployementStartDate
                        }else{
                        UpdateDetails.CurrentProjectStartDate=this.empInfo.CurrentProjectStartDate
                        }

                    if (this.WorkPermit == 'OPT EAD' || this.WorkPermit == 'CPT') {
                        UpdateDetails.IsPaid = this.empInfo.IsPaid
                    }


                    ajax.put(`/Employee/${loggedInUserObj.empId}/Update?loggedInOrgId=${this.loggedInUserObj.orgId}`, UpdateDetails, (res) => {
                        if (res.data.State == true) {
                            localStorage.setItem("LastActivityTime", new Date());
                            events.fire('leftSection')
                            this.updateFlag = false
                            this.$loading({}).close()
                            this.empInfo = null
                            this.getEmployeeDatails()

                            this.$message({
                                type: 'success',
                                message: 'Employee details updated successfully'
                            })
                        }
                        else {
                            this.$loading({}).close()
                            this.ESSEnableDisable(res)
                            this.$message({
                                type: 'error',
                                message: res.data.Message
                            })
                        }
                    })
                }

            },
            updateDocument(index, document) {
                Vue.set(this.rightTCDocsl, index, document)
            },
            updateDocument1(index, document) {
                Vue.set(this.memosWarnsl, index, document)
            },
            updateDocument2(index, document) {
                Vue.set(this.awardsApprel, index, document)
            },
            updateDocument3(index, document) {
                Vue.set(this.federalW4l, index, document)
            },
            updateDocument4(index, document) {
                Vue.set(this.benifitsl, index, document)
            },
            updateDocument5(index, document) {
                Vue.set(this.eduAExpl, index, document)
            },
            updateDocument6(index, document) {
                Vue.set(this.leavesAVacl, index, document)
            },
            updateDocument7(index, document) {
                Vue.set(this.idProofDocsVal, index, document)
            },
            updateDocument8(index, document) {
                Vue.set(this.OrgDocumentsVal, index, document)
            },
            clearDDValues() {
                this.deptList.data = []
                this.veteranList.data = []
                this.ethinicityList.data = []
                this.visaList.data = []
                this.dependantTypeList.data = []
                this.benifitsList.data = []
            },
            setDefaultValues() {
                this.isSending = false
                this.isOnboarded = true
                this.rightTCDocs = null
                this.memosWarns = null
                this.awardsAppre = null
                this.federalW4 = null
                this.benifits = null
                this.eduAExp = null
                this.rightTCDocsl = null
                this.memosWarnsl = null
                this.awardsApprel = null
                this.federalW4l = null
                this.benifitsl = null
                this.eduAExpl = null
                this.idProofDocsVal = null
                this.OrgDocumentsVal = null
                this.idProofDoc = null
                this.OrgDocument = null
                this.leavesAVacl = null
                this.updateFlag = false
                this.empInfo = null
                this.leavesAVac = null
            },
             changeEmpPeriod(val){

                this.empInfo.EmployementStartDate = val
                let todaysDate = moment(new Date())
                let selectedDate = moment(this.empInfo.EmployementStartDate)
                let day = todaysDate.diff(selectedDate, 'days','MM/DD/YYYY')
                var days = Math.floor(day);
                var months = Math.floor(days/30);
                var years = Math.floor(months/12);
                if(days > 0){
                    if(years > 0){
                        if(months > 0){
                            this.empInfo.YearsOfEmployement = (years > 1 ? (years + ' ' + 'Years') : (years + ' ' + 'Year')) + ' ' + ((months % 12) > 1 ? (months % 12 + ' ' + 'Months')  : (months % 12 + ' ' + 'Month'))
                        }
                        else{
                            this.empInfo.YearsOfEmployement = (years > 1 ? (years + ' ' + 'Years') : (years + ' ' + 'Year'))
                        }
                    }
                    else if(months > 0){
                        if(days > 0){
                            this.empInfo.YearsOfEmployement = (months > 1 ? (months + ' ' + 'Months') : (months + ' ' + 'Month')) + ' ' + ((days % 30) > 1 ? (days % 30 + ' ' + 'Days') : (days % 30 + ' ' + 'Day'))
                        }
                        else{
                            this.empInfo.YearsOfEmployement = (months > 1 ? (months + ' ' + 'Months') : (months + ' ' + 'Month'))
                        }
                    }
                    else{
                        this.empInfo.YearsOfEmployement = (days > 1 ? (days + ' ' + 'Days') : (days + ' ' + 'Day'))
                    }
                }
                else if(days < 0){
                    this.empInfo.YearsOfEmployement = "Not Started"
                }
                else {
                    this.empInfo.YearsOfEmployement =  "Started"
                }
            },
            changeContractPeriod(val){

                this.empInfo.CurrentProjectStartDate = val
                let todaysDate = moment(new Date())
                let selectedDate = moment(this.empInfo.CurrentProjectStartDate)
                let day = todaysDate.diff(selectedDate, 'days','MM/DD/YYYY')
                var days = Math.floor(day);
                var months = Math.floor(days / 30);
                var years = Math.floor(months / 12);
                if (Math.sign(days) == 1)
                    if (years > 0)
                        if (months > 0)
                            this.empInfo.YearsOfEmployement = (years > 1 ? (years + ' ' + 'Years') : (years + ' ' + 'Year')) + ' ' + ((months % 12) > 1 ? (months % 12 + ' ' + 'Months') : (months % 12 + ' ' + 'Month'))
                        else
                            this.empInfo.YearsOfEmployement = (years > 1 ? (years + ' ' + 'Years') : (years + ' ' + 'Year'))
                    else if (months > 0)
                        if (days > 0)
                            this.empInfo.YearsOfEmployement = (months > 1 ? (months + ' ' + 'Months') : (months + ' ' + 'Month')) + ' ' + ((days % 30) > 1 ? (days % 30 + ' ' + 'Days') : (days % 30 + ' ' + 'Day'))
                        else
                            this.empInfo.YearsOfEmployement = (months > 1 ? (months + ' ' + 'Months') : (months + ' ' + 'Month'))
                    else
                        this.empInfo.YearsOfEmployement = (days > 1 ? (days + ' ' + 'Days') : (days + ' ' + 'Day'))
                else
                    this.empInfo.YearsOfEmployement = "Not Started"
            },
            viewJobDetails() {
                events.fire("viewJobDetails", this.jobId, '')
            },
            getZipCode(l) {
                setTimeout(() => {
                    if (l.Address.AddressSummary != '') {
                        ajax.get(`/Account/GetZipCode?location=${l.Address.AddressSummary}`, {}, (res) => {
                            if (res.data.State == true) {
                                l.Address.ZipCode = res.data.ZipCodeModel.ZipCode
                            }
                            else{
                                this.ESSEnableDisable(res)
                            }
                        })
                    }
                    else
                        l.Zip = ''

                }, 100)
            },
            onCreatedFrom(e) {
            this.$refs.stayToDate.data.minDate(e.date)
            },
            isEdit() {
                   this.openUpdateEmpPopup = true
                //this.updateFlag = true
                this.$v.empInfo.$reset()
            },
            documentsTableData(docData) {
                let documentsTableData = [];
                docData.MetadataValues.forEach((td) => {
                    let doc = {}
                    doc.DocumentData = []
                    var desc = td.DocumentData.filter((d) => { return d.Key === "Description" })
                    docData.Metadata.forEach((m) => {
                        let value = td.DocumentData.filter((d) => { return d.Key === m.Key })
                        if(m.Key == "Category" && desc && desc.length > 0){
                            value[0].Description = desc[0].Value
                        }
                        doc.DocumentData.push(value[0])
                    })
                    documentsTableData.push(doc)
                })
                return documentsTableData[0].DocumentData
            },
            isMetaDataExists(docData){
                let isMetaData = false;
                docData.MetadataValues.forEach((td) => {
                    docData.Metadata.forEach((m) => {
                        let value = td.DocumentData.filter((d) => { return d.Key === m.Key })
                        if(value[0] && value[0].Value != '')
                            isMetaData = true
                    })
                })
                return isMetaData
            },

            addAddress(){
             this.isHomeEdit = false
             this.openHomeContactPopup = true
           },
            addContact(){
                this.isContactEdit = false
                this.openEmergencyContactPopup = true
            },
            editAddress(obj){
                this.isHomeEdit= true
                this.previousData = obj
                this.openHomeContactPopup = true
            },
            editContact(obj){
                this.isContactEdit = true
                this.contactpreviousData = obj
                this.openEmergencyContactPopup = true
            },
            deleteEmergencyContact(id) {
                this.$loading({ 'loadingText': 'Loading...' })
                ajax.put(`Employee/${loggedInUserObj.empId}/RemoveEmergencyContact?contactId=${id}&loggedInOrgId=${this.loggedInUserObj.orgId}`,{}, (response) => {
                    if(response.data.State == true){
                    this.getEmployeeDatails()
                    this.$message({
                            type: 'success',
                            message: "Emergency Contact Deteted Successfully"
                        });
                        this.$loading({}).close()
                    }
                })
           },
           deletePreviousContact(id) {
            this.$loading({ 'loadingText': 'Loading...' })
            ajax.put(`Employee/${loggedInUserObj.empId}/RemovePreviousAddress?addressId=${id}&loggedInOrgId=${this.loggedInUserObj.orgId}`,{}, (response) => {
                if(response.data.State == true){
                   this.getEmployeeDatails()
                   this.$message({
                        type: 'success',
                        message: "Home Address Deteted Successfully"
                    });
                    this.$loading({}).close()
                }
            })
    },
    getWorkLocationTypeName(){
           if(this.empInfo.WorkLocationAddress != null){
              if(this.empInfo.WorkLocationAddress.WorkLocationType == 'ProjectLocation'){
                  return '(Project Location)'
              }else if(this.empInfo.WorkLocationAddress.WorkLocationType == 'OrganisationLocation'){
                  return '(Organisation Location)'
              }else{
                  if(this.empInfo.WorkLocationAddress.WorkLocationType != '' && this.empInfo.WorkLocationAddress.WorkLocationType != null)
                  return '('+this.empInfo.WorkLocationAddress.WorkLocationType+')'
                  else
                  return ''
              }
           }
        }
        }
    }

</script>

<style lang="scss" scoped>
    @import "~styles/framework/vue-utils";

    @import "~styles/framework/bootstrap/forms";

    .personal-main {
        h4

    {
        color: $ob-brand-primary;
        font-weight: 600;
    }

    .personal-header {
        display: inline-block;
        width: calc(100% - 30px);
        padding: 15px 0 0px 0;
		border-bottom: 1px dashed #ccc;
        margin: 0 15px;
        h4

    {
        /*display: inline-block;*/
        float: left;
    }

    .init-button {
        /*display: inline-block;*/
        float: right;
    }

    }

    .personal-body {
        padding: 0 15px;
        display: inline-block;
        width: 100%;
        min-height: 350px;
        .info-block

    {
        display: inline-block;
        width: 100%;
        border-bottom: 2px dashed #c2c2c2;
        padding-bottom: 10px;
        .info-single

    {
        width: calc(20% - 3px);
        display: inline-block;
        padding: 15px 0;
        vertical-align: top;
        label

    {
        font-size: 11px;
        width: 100%;
        margin: 0;
    }

    .spann {
        display: inline-block;
        color: $ob-brand-primary;
        font-size: 13px;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 140px;
        white-space: nowrap;
    }

    }
    }

    .update-info {
        position: relative;
        .info-single

    {
        width: calc(25% - 4px);
        padding: 15px;
    }

    }

    .inner-heading {
        display: inline-block;
        width: 100%;
        padding: 15px 0px;
        h4

    {
        margin: 0;
    }

    }
    }

    .add-dependent {
        position: relative;
        width: 100%;
        display: inline-block;
        .dependent-common

    {
        position: absolute;
        right: 0;
    }

    .add {
        top: -40px;
    }

    .remove {
        top: -45px;
    }

    }
    }

    .documents-block {
        display: inline-block;
        width: 100%;
        padding: 20px 0;
        .document-block

    {
        .folder-header-heading

    {
        font-weight: 600;
        color: $ob-brand-primary;
    }

    }
    }

    .no-candidates {
        position: absolute;
        left: 35%;
        top: 100px;
        img

    {
        width: 200px;
    }

    }

    .view-job-popup {
        color: #4A90E2;
        display: inline-block;
        font-size: 12px;
        font-style: italic;
        font-weight: 600;
        padding-left: 10px;
        cursor: pointer;
    }

    .remove-color:hover,
    .remove-color {
        float: right;
        color: #F31D1D;
        font-size: 13px;
        font-weight: 600;
        margin-top: 15px;
    }

    .personalfile-details {
        padding: 10px 0;
    }

    .personalfile_data {
        font-weight: 600;
        color: #143361;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .section-personal {
        border-bottom: 2px dashed #c2c2c2;
        padding: 10px 0;
    }

    .deptype-data {
        font-weight: 600;
        color: #143361;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: block;
    }

    .remove-header {
        display: inline-block;
    }

    .add-work-new {
        padding-bottom: 15px;
        a

    {
        color: #5d91e2;
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 15px;
        margin-top: 0;
        margin-left: 15px;
    }

    }

    .border-0 {
        border: 0 !important;
    }

    .empty-projectbtn {
        padding: 5px 15px;
        background: #ffe8c3;
    }

    .btn-projectright {
        float: right;
    }

    .btn-alert-projecttext {
        font-weight: 600;
        color: #333;
        display: inline-block;
        // transform: translatey(5px);
    }

    .benfitdata {
        display: block;
    }

    .personalfile-address {
        padding: 10px 15px;
    }

    .validation-star {
        color: #F31D1D;
    }

    .gender-options {
        margin: 26px 0 0 0;
    }

    .ob-workForce__Status {
        padding: 3px 10px;
        color: #fff;
        font-weight: 500;
        font-size: 10px;
        text-transform: uppercase;
        border-radius: 10px;
        display: inline-block;
        &:hover

    {
        color: #fff;
    }

    }

    .ob-workforce--green {
        background: #3CB55B;
    }

    .ob-workforce--red {
        background-color: #FA6767;
    }

    .remove-emptycount {
        margin-top: -25px;
        &:hover

    {
        margin-top: -25px;
    }

    }

    .p-25 {
        padding-left: 22px
    }

    .no-docs{
        text-align: center;
        padding: 20px;
        font-weight: 600;
        font-size: 13px;
        border-top: 1px dashed #ccc;
    }
    .action_delete{
    font-weight: 600;
    font-style: italic;
    color:#FF1734;
}
.action_update{
    font-weight: 600;
    font-style: italic;
    color:#498FE1;
}
.emergency_info{
    margin-left:0px;
    margin-right: 0px;
}
.personalfile_data_address{
        font-weight: 600;
		color: #143361;
        word-break: break-word;
    }

</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/EmpDetails.vue